import { Column, Entity, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { LeaveApprovalStatusEnum } from '@gtpl/shared-models/common-models'

@Entity('apply_for_leaves')
export class ApplyForLeaves {

    @PrimaryGeneratedColumn('increment', { name: 'apply_for_leaves_id' })
    applyForLeavesId: number;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'employee_id'
    })
    employeeId: number;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'employee_code'
    })
    employeeCode: string;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'employee_name'
    })
    employeeName: string;

    @Column('varchar', {
        nullable: false,
        name: 'type_of_leave'
    })
    typeOfLeave: number;

    @Column({
        nullable: true,
        name: 'from_date'
    })
    fromDate: Date;

    @Column({
        nullable: false,
        name: 'to_date'
    })
    toDate: Date;

    @Column('varchar', {
        nullable: false,
        name: 'leave_from_day'
    })
    leaveFromDay: string;

    @Column('varchar', {
        nullable: false,
        name: 'leave_to_day'
    })
    leaveToDay: string;

    @Column({
        type: "decimal", precision: 10, scale: 1,
        nullable: true,
        name: 'no_of_days'
    })
    noOfDays: number;

    @Column('varchar', {
        nullable: false,
        name: 'leave_reason'
    })
    leaveReason: string;

    @Column('varchar', {
        nullable: false,
        name: 'leave_applied_date'
    })
    appliedDate: string;

    @Column('varchar', {
        nullable: true,
        name: 'leave_address'
    })
    leaveAddress: string;

    @Column({
        type: 'enum',
        enum: LeaveApprovalStatusEnum,
        nullable: true,
        default: LeaveApprovalStatusEnum.OPEN,
        name: 'status'
    })
    status: LeaveApprovalStatusEnum;

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @Column('varchar', {
        nullable: true,
        length: 150,
        name: 'rejection_reason'
    })
    rejectionReason: string;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at',
        type: 'datetime'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
}